/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_Li5Inputs */

const en_guide_json_rest_api_s5_li5 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>pagination</strong> for large collections to avoid sending too much data at once`)
};

const ko_guide_json_rest_api_s5_li5 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대규모 컬렉션에는 <strong>페이지네이션</strong>을 사용하여 한 번에 너무 많은 데이터를 전송하지 마세요`)
};

const ja_guide_json_rest_api_s5_li5 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大量のデータを一度に送信しないように、大きなコレクションには<strong>ページネーション</strong>を使用してください`)
};

/**
* | output |
* | --- |
* | "Use <strong>pagination</strong> for large collections to avoid sending too much data at once" |
*
* @param {Guide_Json_Rest_Api_S5_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_li5 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_li5(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_li5(inputs)
	return ja_guide_json_rest_api_s5_li5(inputs)
});